import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useV1FormsFormInstancesRetrieve, useV1FormsFormInstancesCorrectCreate } from "@/api/generated/v1/v1";
import { DynamicFormRenderer } from "../components/DynamicFormRenderer";
import { usePermission } from "@/auth/usePermission";
import { PageBanner } from "@/shared/components/PageBanner";

export function FormInstanceDetailPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const canCorrect = usePermission("forms.submit");

  const { data: instance, isLoading } = useV1FormsFormInstancesRetrieve(id!);
  const { mutateAsync: correctInstance, isPending } = useV1FormsFormInstancesCorrectCreate();

  const [correcting, setCorrecting] = useState(false);
  const [payload, setPayload] = useState<Record<string, any>>({});

  if (isLoading) {
    return (
      <div className="p-8 flex-center">
        <p style={{ color: "var(--color-text-muted)" }}>در حال بارگذاری...</p>
      </div>
    );
  }

  const def: any = instance?.snapshot_json;

  const startCorrection = () => {
    setPayload(instance?.payload || {});
    setCorrecting(true);
  };

  const handleCorrect = async () => {
    try {
      await correctInstance({ id: id!, data: { payload } as any });
      alert("اصلاحیه ثبت شد.");
      navigate("/forms/instances");
    } catch (err: any) {
      alert(err.response?.data?.detail || "خطا در ثبت اصلاحیه");
    }
  };

  return (
    <div style={{ padding: "0.5rem 0", maxWidth: "100%", margin: "0", display: "flex", flexDirection: "column", gap: "1.5rem" }}>
      <PageBanner
        title={def?.title || "جزئیات فرم ثبت‌شده"}
        subtitle="مشاهده اطلاعات ثبت‌شده و ثبت اصلاحیه"
        icon="📄"
        helpLink="/help/forms/instance-detail"
      >
        <div style={{ display: "flex", gap: "0.75rem", alignItems: "center" }}>
          {canCorrect && !correcting && (
            <button
              onClick={startCorrection}
              style={{
                padding: "0.6rem 1.25rem",
                borderRadius: "12px",
                background: "#ffffff",
                color: "#007270",
                fontWeight: 700,
                fontSize: "0.9rem",
                border: "none",
                cursor: "pointer",
                boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
                display: "flex",
                alignItems: "center",
                gap: "0.5rem",
                transition: "all 0.2s ease",
              }}
            >
              <span>✏️</span>
              <span>ثبت اصلاحیه</span>
            </button>
          )}
          <button
            onClick={() => navigate("/forms/instances")}
            style={{
              padding: "0.6rem 1rem",
              borderRadius: "12px",
              background: "rgba(255, 255, 255, 0.15)",
              color: "#ffffff",
              border: "1px solid rgba(255, 255, 255, 0.3)",
              fontWeight: 700,
              fontSize: "0.85rem",
              cursor: "pointer",
            }}
          >
            ← بازگشت
          </button>
        </div>
      </PageBanner>

      <div className="brand-card-extand" style={{ maxWidth: "800px", margin: "0 auto", padding: "2rem", width: "100%" }}>

        {/* ADR-088 Rule FRM-06: instance اصلی هرگز ویرایش نمیشود؛ فقط نمایش یا ساخت اصلاحیهٔ جدید */}
        <DynamicFormRenderer
          definition={def}
          value={correcting ? payload : instance?.payload || {}}
          onChange={(key, val) => setPayload((p) => ({ ...p, [key]: val }))}
          readOnly={!correcting}
        />

        {correcting && (
          <div className="flex-end mt-6" style={{ gap: "0.75rem" }}>
            <button className="btn btn-secondary" onClick={() => setCorrecting(false)}>
              انصراف
            </button>
            <button className="btn btn-primary" onClick={handleCorrect} disabled={isPending}>
              {isPending ? "در حال ثبت..." : "ثبت نهایی اصلاحیه"}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
